module.exports = __webpack_public_path__ + "static/img/bg_2_2.f02a1b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg_2_2.png
// module id = B+mh
// module chunks = 3